import React, { useState } from 'react';
import { Upload } from 'antd';
import { AntInput } from 'uiKits/Input';
import { useDispatch } from 'react-redux';
import { addImage, setImageUrl, contentMenuActionHandler } from 'slices/editorSlice';
import { useUploadFileMutation, useUploadImageUsingUrlMutation } from 'api/linesheetApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-regular-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import {
  AntdModal,
  Wrapper,
  StyledCancelButton,
  StyledLineSheetsButton,
  TitleWrapper,
  Wrap,
  StyledErrorMessage,
  ImageUsingLinkWrapper,
  Spinner
} from './styles';

const { Dragger } = Upload;

const ImageUploadModal = ({ visible, onClose, imgDiv, pageId, changeImage }) => {
  const dispatch = useDispatch();
  const [imageLink, setImageLink] = useState('');
  const [imageUrl, setIsImageUrl] = useState('');
  const [isFile, setIsFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [uploadFile] = useUploadFileMutation();
  const [uploadImageUsingUrl, { isLoading }] = useUploadImageUsingUrlMutation();
  const [imageError, setImageError] = useState('');

  const handleImageSave = () => {
    onClose();
    if (changeImage) {
      dispatch(setImageUrl(isFile ? fileUrl : imageUrl));
      dispatch(contentMenuActionHandler('changeImage'));
    } else {
      const imageDiv = {
        x: imgDiv.x,
        y: imgDiv.y,
        width: 300,
        height: 300,
        imageUrl: isFile ? fileUrl : imageUrl,
        pageId,
      };

      dispatch(addImage(imageDiv));
    }
  };

  const handleUpload = async ({ file, onSuccess, onError }) => {
    try {
      try {
        const response = await uploadFile(file).unwrap();
        if (response.imageUrl) {
          setFileUrl(response.imageUrl);
          onSuccess('ok');
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
    } catch (err) {
      console.log('err', err);
      onError(err);
    }
  };

  const beforeUpload = (file) => {
    const isImage = ['image/jpeg', 'image/png'].includes(file.type);
    if (!isImage) {
      setImageError('You can only upload JPG/PNG files!');
    }
    const isLt5MB = file.size / 1024 / 1024 < 5;
    if (!isLt5MB) {
      setImageError('Image must be smaller than 5MB!');
    }
    return isImage && isLt5MB;
  };

  const uploadProps = {
    name: 'file',
    multiple: false,
    action: '',
    customRequest: handleUpload,
    beforeUpload,
    onChange(info) {
      setIsFile(info.file);
    },
    onRemove(file) {
      setImageError('');
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  const handleChange = (e) => {
    const url = e.target.value;
    setImageError('');
    setImageLink(url);

    if (url) {
      const img = new Image();
      img.onload = () => {
        // If the image loads successfully, clear any error
        setImageError('');
      };
      img.onerror = () => {
        // If the image fails to load, set an error message
        setImageError('Invalid image URL. Please provide a valid image link.');
      };
      img.src = url;
    }
  };

  const handleImageUpload = async () => {
    try {
      const response = await uploadImageUsingUrl(imageLink).unwrap();
      if (response.imageUrl) {
        setIsImageUrl(response.imageUrl);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      setImageError('Error uploading file');
    }
  };

  return (
    <AntdModal
      open={visible}
      closable={false}
      centered={true}
      footer={
        <Wrapper>
          <StyledCancelButton onClick={onClose}>Cancel</StyledCancelButton>
          <StyledLineSheetsButton
            onClick={handleImageSave}
            disabled={imageError || (imageUrl === '' && fileUrl === null)}
          >
            Save
          </StyledLineSheetsButton>
        </Wrapper>
      }
      width={790}
    >
      <TitleWrapper>Choose Image</TitleWrapper>
      <div>
        <p>{'Paste Image URL'}</p>
        <ImageUsingLinkWrapper>
          <AntInput disabled={fileUrl} value={imageLink} onChange={handleChange} placeholder="Image Url" />
          {isLoading ? <Spinner icon={faSpinner} /> : <FontAwesomeIcon icon={faSquareCheck} size='2xl' onClick={handleImageUpload}/>}
        </ImageUsingLinkWrapper>
        <Wrap>or</Wrap>
        <Dragger disabled={imageUrl} {...uploadProps}>
          <p>Drag and Drop</p>
          <p>or</p>
          <p>Choose Image from Your Computer</p>
        </Dragger>
        <StyledErrorMessage>{imageError}</StyledErrorMessage>
      </div>
    </AntdModal>
  );
};

export default ImageUploadModal;
